// Small clock utilities: debounced intervals and tickers.

/**
 * Start a safe interval. Returns a dispose function.
 * @param {() => void} fn
 * @param {number} ms
 */
export function startInterval(fn, ms) {
  const id = setInterval(() => {
    try { fn(); } catch (e) { void e; }
  }, ms);
  return () => clearInterval(id);
}

/**
 * Debounce helper.
 * @param {Function} fn
 * @param {number} wait
 */
export function debounce(fn, wait = 500) {
  let t;
  return function debounced(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
